var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHintuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 243,
    viewBox: "0 0 255 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 254.188,
    height: 242.083,
    rx: 9,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6973 241.217H240.354C239.739 238.045 237.509 233.459 236.012 231.001C235.056 229.431 234.012 227.988 232.994 226.667C231.438 224.647 231.043 224.449 229.502 222.805C227.961 221.16 223.624 217.28 221.605 215.984C218.923 214.263 215.369 212.349 212.001 210.851C207.02 208.635 166.639 189.618 162.629 187.004C160.227 185.439 157.521 182.255 156.588 178.362C156.205 176.764 155.848 166.284 156.161 164.62C157.079 159.726 159.099 161.268 160.515 154.306C160.956 152.14 160.802 149.808 161.046 147.583C161.669 141.899 164.844 149.086 170.388 134.791C171.759 131.258 174.646 119.476 172.866 116.089C171.588 113.655 169.332 115.052 167.371 114.212C166.753 112.808 168.68 106.347 169.005 104.343C169.604 100.645 169.783 96.3081 169.445 92.4995C168.227 78.8066 160.349 69.9584 147.904 64.9655C141.863 62.5419 134.799 60.7567 127.529 60.5386C114.806 60.1569 101.036 65.5225 92.6039 74.8882C79.3264 89.636 88.4139 112.537 88.1176 114.182C86.5942 115.066 83.926 114.364 82.4922 115.682C79.586 118.354 83.0899 130.572 84.2025 133.598C85.3143 136.622 87.4184 141.728 89.2283 143.266C90.6337 144.461 93.2247 144.461 93.8707 146.001C94.607 147.757 93.1272 153.739 95.9333 158.603C96.9247 160.321 97.7977 161.162 98.3714 163.509C99.0571 166.316 99.0358 174.768 98.4328 177.61C96.6613 185.956 90.3079 188.209 83.057 191.658C76.3519 194.847 69.7838 198.029 63.2028 201.277C56.5923 204.54 49.8752 207.544 43.1122 210.672C39.8479 212.182 36.3831 214.097 33.6056 215.897C25.0442 221.443 17.3301 230.745 14.6975 241.217L14.6973 241.217Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintuser);
export default __webpack_public_path__ + "static/media/hintuser.738296cdda00c5f97214874ab9576c14.svg";
export { ForwardRef as ReactComponent };